import VSlider from './VSlider'

/* istanbul ignore next */
VSlider.install = function install (Vue) {
  Vue.component(VSlider.name, VSlider)
}

export default VSlider



// WEBPACK FOOTER //
// ./src/components/VSlider/index.js